
<div class="alert alert-primary" role="alert">
  <div class=" mx-2 text-center">
    
    <h3>Iniciado em <span>{{dataHoraInicio}}h</span><span *ngIf="dataHoraFim"> com conclusão em {{dataHoraFim}}h</span></h3>
  </div>
</div>

<p-panel *ngIf="participante">
  <p-header>
    <div class="ui-helper-clearfix shadow-lg p-2 mb-2 bg-white rounded">
      <div class=" mx-2 text-center">
        <h3><strong> {{tituloEleicao}} </strong></h3>
        </div>
      <div class=" mx-2 text-center">
        <h3> {{cargo?.nome}} </h3>
        <h5 class="text-danger"> {{cargo?.informacao}}</h5>
      </div>
    </div>
  </p-header>


  <h5 class="text-center text-info">{{cargo?.labelCargo}}</h5>

  <p-table #candidatosList [columns]="cols" [value]="cargo?.candidatos"  [(selection)]="candidatosSelecionados" dataKey="nome"
    [responsive]="true" (onRowSelect)="selecionarCandidato($event, candidatosList)"  (onRowUnselect)="desmarcarSelecao($event, candidatosList)"  >
    <ng-template pTemplate="header" let-columns responsiveLayout="scroll">
      <tr *ngIf="cargo?.candidatos.length">
        <th style="width: 3em">
        </th>

        <th *ngFor="let col of columns">
          
        </th>

        <th style="width: 5em"></th>

      </tr>
    </ng-template>

    <!--Corpo da Tabela-->
    <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded">
      <tr [pSelectableRow]="rowData">
        <td>
          <p-tableCheckbox [value]="rowData" [disabled]="desabilitaCheckbox"></p-tableCheckbox>
        </td>
        <td *ngFor="let col of columns"
            [ngClass]="{'wrap-col-nome': col.field === 'nome'}">
          <ng-container *ngIf="col.field === 'nome'; else defaultCell">
            <span class="preline" [innerHTML]="rowData[col.field]"></span>
          </ng-container>
          <ng-template #defaultCell>
            {{ rowData[col.field] }}
          </ng-template>
          <div #container style="display:inline-block;color:#007bd967; text-align: right;" *ngIf="rowData?.votoJustificavel == true" >
            <a  *ngIf="isAssembleia == false" toolTipStyleClass="tool-custom"  tooltipPosition="right" pTooltip="É necessário justificar o voto para este candidato(a). Para exibir a área de justificativa selecione o candidato ou expanda o currículo clicando na lupa" > 
                <span class="material-icons" style="margin-bottom: -5px;"> info_outline</span>
            </a>
            <a  *ngIf="isAssembleia == true" toolTipStyleClass="tool-custom"  tooltipPosition="right" pTooltip="É necessário justificar o voto para esta resposta. Para exibir a área de justificativa selecione a resposta." > 
              <span class="material-icons" style="margin-bottom: -5px;"> info_outline</span>
            </a>
          </div>
        </td>
        <td class="">
          <a *ngIf=" isAssembleia == false " href="#" [pRowToggler]="rowData" pTooltip="Currículo" class="btn btn-outline-info">
            <i class="fas fa-search-plus"></i>
          </a>
        </td>
      </tr>
    </ng-template>

    <!-- Botões-->
    <ng-template pTemplate="summary">
      <div class="row" *ngIf="cargo?.candidatos.length; else semCandidatos">
        <div class="ml-3 mb-3">
          <div class="text-center mt-3">
            <button [disabled]="desabilitaBotao" class="btn btn-outline-dark btn-lg"
              (click)="limparCandidatosSelecioandos(candidatosList)" >
              Limpar Seleção <i class="fas fa-broom ml-2"></i>
            </button>
          </div>
        </div>
      </div>
      <ng-template #semCandidatos>Nenhum candidato cadastrado para este cargo ainda.</ng-template>

      <div class="row" *ngIf="!eleicaoParametrizacao">
        <div class="col-sm" *ngIf="eleicao.temCancelarVoto">
          <button [disabled]="!desabilitaBotao" type="button" class="btn btn-danger btn-block p-3"
            style="border: 1px solid;" (click)="logout()"> Cancelar <i class="far fa-trash-alt ml-2"></i>
          </button>
        </div>

        <div class="col-sm" *ngIf="eleicao.temVotoNulo">
          <button [disabled]="!desabilitaBotao" type="button" class="btn btn-warning btn-block p-3"
            style="color: white;" (click)="realizarVotoNulo(candidatosList)"> Anular Voto <i class="far fa-trash-alt ml-2"></i>
          </button>
        </div>

        <div class="col-sm" *ngIf="eleicao.temVotoEmBranco">
          <button [disabled]="!desabilitaBotao" type="button" class="btn btn-dark btn-block p-3"
            style="border: 1px solid;" (click)="realizarVotosEmBranco(candidatosList)"> Votar em Branco <i
              class="fas fa-times ml-2"></i>
          </button>
        </div>

        <div class="col-sm">
          <button [disabled]="desabilitaBotao || votoUnique" type="button" class="btn btn-success btn-block p-3"
            style="border: 1px solid;" (click)="realizarVoto()"> Confirmar Voto <i class="fas fa-check ml-2"></i>
          </button>
        </div>
      </div>
    </ng-template>

    <!-- Template de Curriculum-->
    <ng-template pTemplate="rowexpansion" let-rowData let-columns="columns">
      <tr>
        <td [attr.colspan]="columns.length + 2">
          <div class="ui-g ui-fluid" style="font-size:16px;padding:20px">
            <div *ngIf="validaEntidadeEleicao == false" class="ui-g-12 ui-md-3" style="text-align:center">
              <img *ngIf="rowData?.imagem" [attr.alt]="rowData.urlImagem" src="{{rowData?.imagem}}"
                class="img-fluid" alt="Responsive image">
              <img *ngIf="!rowData?.imagem" [attr.alt]="rowData.urlImagem" [src]=""
                class="img-fluid" alt="Responsive image">
            </div>
            <div class="ui-g-12" [ngClass]="(validaEntidadeEleicao == false && rowData?.imagem != '') ? 'ui-md-9' : 'ui-md-12' ">
              <div class="ui-g">
                <div class="ui-g-12" [ngClass]="validaEntidadeEleicao == false ? 'text-justify' : '' ">
                  <h4 class="text-dark mb-3 preline" *ngIf="rowData?.curriculum != null" [innerHTML]="rowData?.nome"></h4>
                  <div>
                    <div [innerHtml]="rowData?.curriculum" class="text-justify" appResponsiveHtml></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </td>
      </tr>
        <!-- justificativa --> 
        <tr *ngIf="rowData?.votoJustificavel == true  && (rowData?.selecionado != null && rowData?.selecionado == true ) && candidatoJustificativaSelecionado == true"  >
         <!--  <tr *ngIf="rowData?.votoJustificavel == true" > -->
          <td [attr.colspan]="columns.length + 2">
            <div class="ui-g ui-fluid" style="font-size:16px;padding:20px">
            
              <div class="ui-g-12" [ngClass]="(validaEntidadeEleicao == false && rowData?.imagem != '') ? 'ui-md-9' : 'ui-md-12' ">
                <div class="ui-g">
                  <div class="ui-g-12" [ngClass]="validaEntidadeEleicao == false ? 'text-justify' : '' ">
                    <h4 class="text-dark"> {{rowData?.parametroJustificativa}}</h4>
                    <div>
                      <textarea id="justificativa_voto_{{rowData.id}}"  (keyup)="countJustificativa($event)"  style="height: 150px; min-height: 0px; width: 100%; background-color: #f8f8f8;   border: 2px solid #007ad9; " maxlength="200"></textarea>
                      <div id="the-count">
                        <span id="char_count_justificativa_voto_{{rowData.id}}">200/200</span>
                      </div>
                    </div>                 
                  </div>                
                </div>              
              </div>     
            </div>
          </td>
      </tr>
       <!-- justificativa -->
    </ng-template>
  </p-table>
</p-panel>

<p-confirmDialog #cd header="Confirmação" icon="pi pi-exclamation-triangle" [transitionOptions]="'0.3s'">
  <p-footer>
    <div class="d-flex flex-row justify-content-between gap-3">
      <button type="button" class="btn btn-info px-4 py-2 d-flex align-items-center justify-content-center" (click)="cd.accept()">
        <i class="fas fa-check-circle mr-2"></i> Sim
      </button>
      <button type="button" class="btn btn-warning px-4 py-2 d-flex align-items-center justify-content-center" (click)="cd.reject()">
        <i class="fas fa-times mr-2"></i> Não
      </button>
    </div>
  </p-footer>
</p-confirmDialog>
